import React from 'react';
import type { AdminInquiry } from '../../../types';
import InlineReplyForm from './InlineReplyForm';
import ReplyReadOnlyBlock from './ReplyReadOnlyBlock';

interface InquiryRowExpandedProps {
  inquiry: AdminInquiry;
  onReplySuccess: () => void;
  /** Number of columns in the parent table, so the expanded <td> can span them. */
  colSpan: number;
}

/**
 * Expanded detail panel shown beneath an active InquiryRow. Renders the full
 * title / content and either the inline reply form (unanswered) or a
 * read-only reply block (already answered).
 */
const InquiryRowExpanded: React.FC<InquiryRowExpandedProps> = ({
  inquiry,
  onReplySuccess,
  colSpan,
}) => {
  const hasAnswer = typeof inquiry.answer === 'string' && inquiry.answer.trim().length > 0;

  return (
    <tr className="border-t border-gray-100 bg-gray-50/70">
      <td colSpan={colSpan} className="px-6 py-5">
        <div className="space-y-3">
          <h3 className="text-base font-semibold text-gray-900 break-words">{inquiry.title}</h3>
          <p className="text-sm text-gray-700 whitespace-pre-wrap break-words">
            {inquiry.content}
          </p>

          {hasAnswer ? (
            <ReplyReadOnlyBlock
              answer={inquiry.answer as string}
              answeredAt={inquiry.answeredAt}
              answeredBy={inquiry.answeredBy}
              answeredByName={inquiry.answeredByName}
            />
          ) : (
            <InlineReplyForm
              inquiryId={inquiry.inquiryId}
              onReplySuccess={onReplySuccess}
            />
          )}
        </div>
      </td>
    </tr>
  );
};

export default InquiryRowExpanded;
